<div class="desktop">
	<div class="list">
		<div class="listItem">
			<div class="nav-item">
				<a class="link" routerLink="whatIsBeachwatch">About Beachwatch</a>
			</div>		
			<div class="nav-item">
				<a class="link" routerLink="waterMonitoring">Water monitoring</a>
			</div>		
			<div class="nav-item">
				<a class="link" routerLink="beachwatchPartners">Beachwatch partners</a>
			</div>		
			<div class="nav-item">
				<a class="link" routerLink="contactUs">Contact us</a>
			</div>		
			<div class="nav-item">
				<a class="link" routerLink="yourFavourites">Your favourites</a>
			</div>		
		</div>
	</div>
</div>